module.exports = __webpack_public_path__ + "img/salsa_1963.4c8ffb80.jpg";